import { useState } from "react";

// Delete Confirmation Modal
interface DeleteModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    itemName: string;
  }
  
  export function DeleteModal({ isOpen, onClose, onConfirm, itemName }: DeleteModalProps) {
    const [loading, setLoading] = useState(false);
  
    const handleDelete = async () => {
      setLoading(true);
      try {
        await onConfirm();
        onClose();
      } catch (error) {
        console.error("Delete failed:", error);
      } finally {
        setLoading(false);
      }
    };
  
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
        <div className="bg-white rounded-lg p-6 shadow-lg w-96">
          <h2 className="text-xl font-semibold text-red-600">Warning</h2>
          <p className="mt-2 text-gray-700">Are you sure you want to delete <span className="font-bold">{itemName}</span>?</p>
          <div className="mt-4 flex justify-end space-x-2">
            <button 
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              onClick={onClose} 
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className={`px-4 py-2 text-white rounded-lg ${loading ? 'bg-red-400' : 'bg-red-600 hover:bg-red-700'}`} 
              onClick={handleDelete} 
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    );
  }